import styled from '@emotion/styled';
import { TableCell } from '@mui/material';

export const StyledCell = styled(TableCell)(() => ({
  borderRight: '1px solid lightGray',
}));
